import request from "./axiosConfig";

/**
 * 获取问卷题目列表
 */
export function getSurveyQuestions() {
  return request({
    url: "/interface/survey/questions",
    method: "get",
  });
}

/**
 * 保存问卷答案
 */
export function saveSurveyAnswers(data) {
  return request({
    url: "/interface/survey/save",
    method: "post",
    data: data,
  });
}

/**
 * 获取志愿规划建议结果
 */
export function getSurveyResult(data) {
  return request({
    url: "/interface/survey/result",
    method: "post",
    data: data,
  });
}

/**
 * 查询志愿规划评测记录
 */
export function getEvaluationRecords() {
  return request({
    url: "/interface/survey/evaluationQuery",
    method: "get",
  });
}
